var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',[_vm._v("When you are close, a sign shall be given.")]),_c('div',{staticStyle:{"height":"calc(clamp(2rem, 17.6vmin, 4.5rem) * 0.3)"}},[_c('ProgressIndicator',{attrs:{"progress":_vm.progress}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }